export function emailWrapper(email: string) {
  return (
    '<table style="padding:15px 25px"><tr><td>' +
    email +
    '<br><br><img src="https://ats.no/images/ats-logotype-black.png" alt="ATS" style="width:80px;height:auto">' +
    '</td></tr></table>'
  );
}
